module.exports = __webpack_public_path__ + "static/media/allergen_peanut.c4b898de.c4b898de.png";